import React from 'react';
import Footer from '../Footer/Footer';
import Product from '../Product/Product';
import SubHeader from '../SubComp/SubHeader/SubHeader';
import Header from './../Header/Header';

const ThisWeek = () => {
    return (
        <div className="bg_Dark">
            <Header/>
            <SubHeader title="New Arrival" text="New Arrival"  width='container'/>
            <div className="container my-5">
                <h1 className='text-white bold mb-4'>This Week</h1>
                <Product />
            </div>
            <Footer displayNone='d-none' />
        </div>
    );
};

export default ThisWeek;